function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null);

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M-1220-187h0l-34.93-34.87a13.68,13.68,0,0,0-19.32,0l-34.93,34.94a3.5,3.5,0,0,0,0,4.93,3.39,3.39,0,0,0,4.86,0l1-1v34a8.8,8.8,0,0,0,8.88,8.71h59.68a8.62,8.62,0,0,0,8.58-8.71v-34.11L-1225-182a3.68,3.68,0,0,0,5-.05A3.54,3.54,0,0,0-1220-187Zm-52.57,18.37a2.6,2.6,0,0,1,2.73-2.36h10.53a2.35,2.35,0,0,1,2.42,2.36v21.32h-15.68v-21.32Zm13.26-9.4h-10.53a9.38,9.38,0,0,0-9.45,9.4v21.32h-15.12a1.74,1.74,0,0,1-1.84-1.67v-41l26.91-26.89a6.62,6.62,0,0,1,4.71-2,6.45,6.45,0,0,1,4.65,2L-1233.2-190v41a1.49,1.49,0,0,1-1.54,1.67h-15.1v-21.32A9.48,9.48,0,0,0-1259.31-178.07Z",
  transform: "translate(1310.18 225.88)"
});

var SvgHomeIcon = function SvgHomeIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 91.19 85.59",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHomeIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Home_icon.186c7452.svg";
export { ForwardRef as ReactComponent };